export enum ZIndex {
    Modal = 1000,
    Tooltip = 1500
}
